import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const GatewayMessageLogList = () => {
  const fetchUrl = `${API_DOMAIN}${API_ROUTES.gatewayMessageLog}`;

  const columns = [
    { label: 'Message Type', value: 'message_type' },
    { label: 'Status', value: 'status' },
    { label: 'Attempt Count', value: 'attempt_count' },
    { label: 'Response Code', value: 'response_code' },
  ];

  const handleAccessDetails = (id) => {
    window.location.href = `/customer/gateway-message-log/details/${id}`;
  };

  return (
    <div>
      <h1>Gateway Message Logs</h1>
      <ListTemplate
        fetchUrl={fetchUrl}
        columns={columns}
        onAccessDetails={handleAccessDetails}
      />
    </div>
  );
};

export default GatewayMessageLogList;
